import styled from 'styled-components';

const ListDivider = styled.div`
  border-bottom: 1px solid rgba(111, 125, 141, 0.2);
`;

export default ListDivider;
